export const formInputDark = {
  height: 44,
  backgroundColor: 'grey/dark/background',
  color: 'white',
  labelVariant: 'p1',
  borderRadius: 'xl',
  paddingLeft: 'm',
  paddingRight: 'm',
  paddingBottom: 'none',
  placeholderVariant: 'p1',
  placeholderPropsStyle: {
    color: 'grey/light',
    paddingLeft: 'm',
    paddingRight: 'm',
  },
  labelPropsStyle: {
    color: 'white',
  },
  colorOnFocus: 'white',
  py: 'none',
  inputTextStyle: {
    fontSize: 'm',
    color: 'white',
  },
};
